const query = q => document.querySelector(q)
export class BaseFieldValidator {

    constructor(fields = {}) {
        this.DEFAULT_INVALID_CLASS = 'has-error'
        this.DEFAULT_VALID_CLASS = 'has-success'
        this.data = {
            name: 'hello'
        }

        this.fields = fields
    }
    setFields(data) {
        this.fields = data
    }
    run() {
        if (!this.fields) {
            console.error("fields not matchec")
            return
        }
        this.fields.forEach(field => {
            const e = query(field.target) 
        })
    }

    _checkEmptyField() {

    }
    _getDOMElement(e) {

    }
}


// WEBPACK FOOTER //
// ./src/components/parts/utils/base-validator/index.js